import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const ReusableDataGrid = ({
  rows,
  columns,
  getRowId,
  loading,
  pageSize = 10,
  pageSizeOptions = [10, 25, 50, 100],
  ...props
}) => (
  <DataGrid
    rows={rows}
    columns={columns}
    getRowId={getRowId}
    pagination
    pageSizeOptions={pageSizeOptions}
    autoHeight
    disableSelectionOnClick
    loading={loading}
    sx={{
      width: '100%',
      '& .MuiDataGrid-columnHeaders': {
        background: 'linear-gradient(90deg, #e3f2fd 0%, #bbdefb 100%)',
        color: '#222',
        fontWeight: 'bold',
        fontSize: 16,
        zIndex: 1,
      },
      '& .MuiDataGrid-row:hover': {
        backgroundColor: '#e3f2fd',
      },
    }}
    {...props}
  />
);

export default ReusableDataGrid;